import React from 'react';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@roger/ui-components';

interface Props {
  icon: React.ReactNode;
  /** Both the tooltip text and the accessible name, so they cannot drift. */
  label: string;
  onClick?: () => void;
  disabled?: boolean;
}

/**
 * A 32px icon-only button with its label on hover.
 *
 * Icon-only is what lets a header row of controls sit on one baseline with the
 * tab list; the tooltip is what keeps it legible. Keeping the pairing in one
 * component means a future button cannot ship with a tooltip and no aria-label.
 */
export function IconTooltipButton({ icon, label, onClick, disabled }: Props) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type='button'
            variant='outline'
            size='iconMd'
            aria-label={label}
            onClick={onClick}
            disabled={disabled}
          >
            {icon}
          </Button>
        </TooltipTrigger>
        <TooltipContent side='bottom'>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
